import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['avaliado', 'lotacaoServidor','lotacaoAvaliador', 'periodicidade',
    'tipoEntrega', 'ano', 'mes', 'status', 'numero', 'tipoRelatorio',
    'resultadosPorPagina', 'semana', 'ordenarPor', 'tipoLotacao', 'tipoVinculo'];

  limparFormulario() {
    this.avaliadoTarget.value = '';

    if (this.hasLotacaoServidorTarget) {
      this.lotacaoServidorTarget.value = '';
      this.tipoLotacaoTarget.value = '';
    }

    if (this.hasLotacaoAvaliadorTarget) {
      this.lotacaoAvaliadorTarget.value = '';
    }

    if(this.hasTipoRelatorioTarget) {
      this.tipoRelatorioTarget.value = '';
    }

    this.periodicidadeTarget.value = '';
    this.tipoEntregaTarget.value = '';
    this.anoTarget.value = '';
    this.mesTarget.value = '';
    this.statusTarget.value = '';
    this.numeroTarget.value = '';
    this.semanaTarget.value = '';
    this.tipoVinculoTarget.value = '';
    this.resultadosPorPaginaTarget.value = '50';
    this.ordenarPorTarget.value = 'status';

    const form = document.getElementById('form-busca-gerenciar-relatorios');
    window.location.href = form.action;
  }
}